import { Fragment, useCallback, useEffect, useRef, useState } from "react";
import "./user_dashboard_content_component.scss";
import { v4 as uuidv4 } from "uuid";
import DashboardSlider from "./dashboard_utlility_components/dashboard_slider/dashboard_slider";
import SubjectCollectionView from "./dashboard_utlility_components/subject_collection_view/subject_collection_view";
import LastPausedVideo from "./dashboard_utlility_components/last_paused_video/last_paused_video";
import ScheduleClass from "./dashboard_utlility_components/schedule_class/schedule_class";
import NewOfferingsSlider from "./dashboard_utlility_components/dashboard_slider/new_offerings_slider";
import AitsBanner from "./dashboard_utlility_components/aits_banner/aits_banner";
import axios from "axios";
import CustomModal from "../../../../components/Modal/CustomModal";
import {
  url_8,
  url_172,
  url_173,
  url_54,
  url_211,
} from "../../../../custom_utilities/api_services";
import images from "../../../../utilities/images/images";
import Our_course_package from "./dashboard_utlility_components/our_course_package/Our_course_package";
import { toastifyMessage } from "../../../../custom_utilities/toastify_config";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BASE_URL } from "../../../../custom_utilities/baseURL";
import { isEmpty } from "../../../../custom_utilities/custom_useful_functions";
import MultipleLoginDetectModal from "../../../../containers/multiple_login_detected_popup/MultipleLoginDetectModal";
import FreeWatchVideosModal from "../../../../components/FreeWatchVideosModal/FreeWatchVideosModal";
import TenHoursFreeVideosBanner from "./dashboard_utlility_components/ten_hours_free_videos_banner/TenHoursFreeVideosBanner";
import AnushashanModal from "../../user_edit_profile/anushashan/AnushashanModal";
import FreeTrialBanner from "../../user_edit_profile/anushashan/FreeTrialBanner";
import SmartTrialModal from "../../user_edit_profile/anushashan/SmartTrialModal";
import DiscountModal from "../../user_edit_profile/anushashan/DiscountModal";
import DiscountBanner from "../../user_edit_profile/anushashan/DiscountBanner";
import useAuthUtils from "../../../../hooks/auth/useAuthUtils";
import NewUserTrialModal from "../../user_edit_profile/new_user_trial/New_User_Trial";
import FreeBenifits from "../../user_edit_profile/new_user_trial/FreeBenifits";
import TrialMessageModal from "../../user_edit_profile/new_user_trial/TrialMessage";
import AcpsHomePageBanner from "../acps-banners/AcpsHomePageBanner";
import SalesBanner from "../sales/SalesBanner";
import FlashSale from "../sales/flash-sales/FlashSale";
import Testimonial from "../testimonials/Testimonial";
import ComboPackages from "../sales/combo-packages/ComboPackages";
import ComboMessage from "../sales/combo-packages/combo-message/ComboMessage";
import { getRemainingUserTimeSeconds } from "../../../../shared/utilities/helpers/resolveFreeWatchRemaining";

const FREE_WATCH_MODAL_SESSION_KEY = "motion_dismiss_free_watch_videos_modal";

const UserDashboardContentComponent = (props) => {
  let {
    history,
    startLoading,
    finishLoading,
    setBlockedStatusAction,
    setCategoryData,
    setIsCategorizedSub,
    userPreference,
  } = props;
  const [state, setState] = useState({
    feedbackModal: false,
    successModal: false,
    showUserRegistrationModal: 0,
    is_complete_profile: 1,
    isActive: 1,
    showFeePendingPopup: false,
    feePendingData: {},
    roll_no: "",
    mobile_no: "",
    error: false,
    responseData: {},
    is_Amrit: false,
    aits_pdf: "",
    amrit_pdf: "",
    feedbackData: {
      teaching_method: "0",
      punctuality: "0",
      behaviour: "0",
      theory_quality: "0",
      discussion_quality: "0",
      overall: "0",
    },

    newofferings: [],
    programs: [],
    isPaid: null,
    remainingUserTimeToWatchVideo: null,
    isPaid1: null,
    acpsBannerData: [],
    salesData: [],
    flashSalesData: [],
    testimonialData: [],
    comboPackagesData: {},
    comboMessage: null,
  });

  const { headers } = useAuthUtils();
  const [isMultipleLogin, setIsMultipleLogin] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [showAnushashanModal, setShowAnushashanModal] = useState(false);
  const [showFreeTrialModal, setShowFreeTrialModal] = useState(false);
  const [showSmartTrialModal, setShowSmartTrialModal] = useState(false);
  const [showNewTrailModal, setShowNewTrialModal] = useState(true);
  const [showNewTrailMessageModal, setShowNewTrialMessageModal] =
    useState(true);
  const [showDiscountModal, setShowDiscountModal] = useState(false);
  const [showDiscountBanner, setShowDiscountBanner] = useState(false);
  const [showFreeTrailModalData, setShowFreeTrialModalData] = useState({
    free_benefits: [],
    home_benefits: [],
    trial_message: "",
  });
  const [discountData, setDiscountData] = useState({
    title: "",
    description: "",
    discountPercent: "",
    couponCode: "",
    couponNote: "",
  });
  const [freeWatchModalDismissedSession, setFreeWatchModalDismissedSession] =
    useState(() => {
      if (typeof window === "undefined") return false;
      return sessionStorage.getItem(FREE_WATCH_MODAL_SESSION_KEY) === "1";
    });
  const [freeTrialData, setFreeTrialData] = useState({
    trialDays: 0,
    packageId: "",
    popupTitle: "",
    popupDescription: "",
  });

  const getUserProfile = useCallback(async () => {
    let id = window.localStorage.getItem("device_id");

    if (!id) {
      id = uuidv4();
      window.localStorage.setItem("device_id", id);
    }

    try {
      const response = await axios.get(`${url_8}?device_id=${id}`);

      if (response.data.status === 200) {
        const profile = response.data.data;
        const remainingSec = getRemainingUserTimeSeconds(profile);
        if (remainingSec <= 0 && typeof window !== "undefined") {
          sessionStorage.removeItem(FREE_WATCH_MODAL_SESSION_KEY);
          setFreeWatchModalDismissedSession(false);
        }

        setState((prevState) => ({
          ...prevState,
          is_Amrit: profile.is_Amrit,
          aits_pdf: profile.aits_pdf,
          amrit_pdf: profile.amrit_pdf,
          showUserRegistrationModal: profile.is_user_registration,
          is_complete_profile: profile.is_form_submit,
          isActive: profile.active,
          feePendingData: profile.fee_pending,
          showFeePendingPopup: profile.fee_pending.show_popup,
          roll_no: profile.roll_no,
          mobile_no: profile.mobile,
          isPaid: profile.is_paid,
          remainingUserTimeToWatchVideo: remainingSec,
          isPaid1: profile.is_paid,
          salesData: profile.sales_banner,
          flashSalesData: profile.flash_sales,
          testimonialData: profile.motion_testimonials,
          comboPackagesData: profile.combo,
          comboMessage: profile.combo_message,
        }));
        setCategoryData({
          category: profile.category,
        });
        setIsCategorizedSub({
          is_categorized_sub: profile.is_categorized_sub,
        });
        setBlockedStatusAction({
          user_block: profile.user_block,
        });
        setShowFreeTrialModalData({
          free_benefits: profile.free_benefits || [],
          home_benefits: profile.home_benefits || [],
          trial_message: profile.trial_message || "",
        });
        setIsMultipleLogin(false);
      } else {
        setState((prevState) => ({
          ...prevState,
          showUserRegistrationModal: 0,
        }));
        setBlockedStatusAction({
          isBlocked: false,
          remark: null,
          user_block: {},
        });
        setIsMultipleLogin(true);
      }
    } catch (error) {
      toastifyMessage({
        status: 201,
        message: "An error occurred while fetching user profile.",
      });
    }
  }, [setBlockedStatusAction]);

  useEffect(() => {
    set_record();
    getFeedBackPopup();
    getUserProfile();
    getSliderImg();
  }, [getUserProfile]);

  const getSliderImg = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}/api/ots/get/homeslidelist?version=1`
      );

      if (response.data.status === 200) {
        setState((prevState) => ({
          ...prevState,
          newofferings: [...response.data.data.slidelist],
          programs: [...response.data.data.Motion_Program],
        }));
      }
    } catch (error) {
      console.log(error);
    }
  };

  const set_record = async () => {
    let data = {
      apk_version: "Web",
    };

    try {
      await axios.post(url_54, data);
    } catch (error) {
      console.log(error);
    }
  };
  const handleClose = () => {
    setState((prev) => {
      return {
        ...prev,
        feedbackModal: false,
        successModal: false,
        error: false,
      };
    });
  };

  const handleCloseFreeWatchVideos = () => {
    if (typeof window !== "undefined") {
      sessionStorage.setItem(FREE_WATCH_MODAL_SESSION_KEY, "1");
    }
    setFreeWatchModalDismissedSession(true);
  };

  const getFeedBackPopup = async () => {
    try {
      const response = await axios.post(url_172);
      if (Object.keys(response.data.data).length > 0) {
        if (response.data.data.feedback !== null) {
          const feedback = response.data.data.feedback;
          setState((prev) => {
            return {
              ...prev,
              responseData: feedback,
              feedbackModal: true,
              feedbackData: {
                ...prev.feedbackData,
                student_id: feedback.stud_rollno,
                batch_id: feedback.batch_id,
                batch_code: feedback.batch_code,
                topic_title: feedback.topic_title,
                topic_no_count: feedback.topic_no_count,
                session_id: feedback.session_id,
                center_id: feedback.center_id,
                faculty_id: feedback.faculty_id,
                st_feedback_show_id: feedback.id,
              },
            };
          });
        }
      }
    } catch (error) {
      console.log(error);
    }
  };
  const feedbackValidation =
    state.feedbackData.teaching_method === "0" ||
    state.feedbackData.punctuality === "0" ||
    state.feedbackData.behaviour === "0" ||
    state.feedbackData.theory_quality === "0" ||
    state.feedbackData.discussion_quality === "0" ||
    state.feedbackData.overall === "0";

  const FeedBackArr = [
    {
      title: "Teaching Method",
      name: "teaching_method",
    },
    {
      title: "Punctuality",
      name: "punctuality",
    },
    {
      title: "Behaviour",
      name: "behaviour",
    },
    {
      title: "Theory Quality",
      name: "theory_quality",
    },
    {
      title: "Discussion Quality",
      name: "discussion_quality",
    },
    {
      title: "Overall",
      name: "overall",
    },
  ];
  const feedBackInput = (e) => {
    setState((prevState) => {
      return {
        ...prevState,
        feedbackData: {
          ...prevState.feedbackData,
          [e.target.name]: e.target.value,
        },
      };
    });
  };
  const feedbackSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(url_173, state.feedbackData);
      if (response.status == 200) {
        setState((prev) => {
          return {
            ...prev,
            feedbackModal: false,
            successModal: true,
            error: false,
          };
        });
      }
    } catch (error) {
      console.log(error);
      setState((prev) => {
        return {
          ...prev,
          error: true,
        };
      });
    }
  };

  const handleCloseProfileform = () => {
    setState((prevState) => ({
      ...prevState,
      is_complete_profile: 1,
    }));
  };

  const handleCloseFeePendingModal = () => {
    setState((prevState) => {
      return {
        ...prevState,
        showFeePendingPopup: !state.showFeePendingPopup,
      };
    });
  };

  const handleWatchNow = () => {
    history.push("/subject_component");
    handleCloseFreeWatchVideos();
  };

  const sendSmsToStudent = async () => {
    startLoading();
    try {
      const data = {
        method_name: "send_link_api",
        mobile: state.mobile_no,
        roll_no: state.roll_no,
      };
      const response = await axios.post(url_211, data);
      if (response.data.response.status.toLowerCase() === "success") {
        finishLoading();
        handleCloseProfileform();
        toastifyMessage({
          status: 200,
          message: "You will get an SMS shortly",
        });
      } else {
        finishLoading();
        handleCloseProfileform();
        toastifyMessage({
          status: 201,
          message: response.data.response.message,
        });
      }
    } catch (error) {
      console.log(error);
      finishLoading();
      handleCloseProfileform();
      toastifyMessage({
        status: 201,
        message: "Error",
      });
    }
  };

  const handleCloseAnushashanModal = () => {
    setShowAnushashanModal(false);
  };

  useEffect(() => {
    fetchAnushashanData();
  }, []);

  const fetchAnushashanData = async () => {
    try {
      const response = await axios.get(
        "https://learning.motion.ac.in/motioneducation/api/v1/runSmartTrialChecks"
      );

      if (response.status === 200) {
        const popupData = response.data?.smart_trial_data;
        const showPopup = popupData?.show_smart_trial_popup;

        // Flags for modal and banner
        const shouldShowDiscountModal = showPopup === 2;
        const shouldShowDiscountBanner = showPopup === 2 || showPopup === 22;

        setShowDiscountModal(shouldShowDiscountModal);
        setShowDiscountBanner(shouldShowDiscountBanner);

        // Set shared discount data for both DiscountModal and DiscountBanner
        if (shouldShowDiscountModal || shouldShowDiscountBanner) {
          setDiscountData({
            title: popupData?.popup_title || "",
            description: popupData?.popup_description || "",
            discountPercent: popupData?.discount_percentage || "",
            couponCode: popupData?.coupon_code || "",
            couponNote: popupData?.coupon_note || "",
            packageId: popupData?.trial_package_info?.package_id,
          });
        }

        // Handle other modals
        const shouldShowAnushashan = showPopup === 1;
        const shouldShowFreeTrial = showPopup === 1 || showPopup === 11;

        if (shouldShowFreeTrial) {
          setFreeTrialData({
            trialDays: popupData.trial_days,
            packageId: popupData?.trial_package_info?.package_id,
            popupTitle: popupData?.popup_title,
            popupDescription: popupData?.popup_description,
          });
        }

        setShowAnushashanModal(shouldShowAnushashan);
        setShowFreeTrialModal(shouldShowFreeTrial);
      }
    } catch (err) {
      console.error("Anushashan fetch failed:", err);
    }
  };

  const fetchTrial = async () => {
    if (!freeTrialData?.packageId) {
      console.error("No packageId available for smart trial");
      return;
    }

    try {
      const response = await axios.post(
        `https://learning.motion.ac.in/motioneducation/api/v1/startSmartTrial?package_id=${freeTrialData.packageId}`,
        { headers }
      );

      if (response.data.status === 200) {
        setModalData({
          title: response.data.popup_title,
          description: response.data.popup_description,
          benefits: response.data.popup_benefits,
        });
        setShowAnushashanModal(false);
        setShowSmartTrialModal(true);
      }
    } catch (err) {
      console.error("Trial fetch failed:", err);
    }
  };

  return (
    <Fragment>
      {showAnushashanModal && freeTrialData && (
        <AnushashanModal
          onClose={handleCloseAnushashanModal}
          onStartTrial={fetchTrial}
          popupTitle={freeTrialData.popupTitle}
          popupDescription={freeTrialData.popupDescription}
        />
      )}
      {showSmartTrialModal && (
        <SmartTrialModal
          isOpen={true}
          onClose={() => setShowSmartTrialModal(false)}
          popupTitle={modalData?.title || ""}
          popupDescription={modalData?.description || ""}
          popupBenefits={modalData?.benefits || []}
        />
      )}
      {showDiscountModal && discountData && (
        <DiscountModal
          title={discountData.title}
          description={discountData.description}
          discountPercent={discountData.discountPercent}
          couponCode={discountData.couponCode}
          couponNote={discountData.couponNote}
          onClose={() => setShowDiscountModal(false)}
          history={history}
          packageId={discountData.packageId}
        />
      )}
      {showNewTrailModal &&
        showFreeTrailModalData?.free_benefits?.length > 0 && (
          <NewUserTrialModal
            isOpen={showNewTrailModal}
            onClose={() => setShowNewTrialModal(false)}
            freeBenefits={showFreeTrailModalData.free_benefits}
          />
        )}
      {showNewTrailMessageModal &&
        showFreeTrailModalData?.trial_message?.length > 0 && (
          <TrialMessageModal
            isOpen={showNewTrailMessageModal}
            onClose={() => setShowNewTrialMessageModal(false)}
            freeBenefits={showFreeTrailModalData.trial_message}
          />
        )}
      <CustomModal show={state.feedbackModal} onHide={handleClose}>
        <p className="text-muted text-center mb-0">
          Share your valuable Feedback for today's Topic
        </p>
        <p className="text-center">
          <b>{`${state.responseData.topic_title} By ${state.responseData.faculty_name} in Batch ${state.responseData.batch_code}`}</b>
        </p>
        <form onSubmit={feedbackSubmit} style={{ padding: "8px" }}>
          {FeedBackArr?.map((element, index) => (
            <div className="mb-2" key={index}>
              <h6>{element.title}</h6>
              <div className="emojiContainer">
                <div className="emojiLine"></div>

                <div className="emojiDiv">
                  <input
                    type="radio"
                    id={`${element.name}-average`}
                    value="2"
                    name={element.name}
                    onChange={feedBackInput}
                    style={{ display: "none" }} // Hide the default radio button
                  />
                  <label
                    htmlFor={`${element.name}-average`}
                    className="emojiLabel emojiAve"
                  >
                    <span className="emojiImage">
                      <img
                        style={{ width: "40px", height: "40px" }}
                        alt="average"
                        src={images.Average}
                      />
                    </span>
                    <p className="emojitext">Average</p>
                  </label>
                </div>

                <div className="emojiDiv">
                  <input
                    type="radio"
                    id={`${element.name}-good`}
                    value="3"
                    name={element.name}
                    onChange={feedBackInput}
                    style={{ display: "none" }}
                  />
                  <label
                    htmlFor={`${element.name}-good`}
                    className="emojiLabel emojiGood"
                  >
                    <span className="emojiImage">
                      {" "}
                      <img
                        style={{ width: "40px", height: "40px" }}
                        alt="average"
                        src={images.Good}
                      />
                    </span>
                    <p className="emojitext">Good</p>
                  </label>
                </div>

                <div className="emojiDiv">
                  <input
                    type="radio"
                    id={`${element.name}-great`}
                    value="4"
                    name={element.name}
                    onChange={feedBackInput}
                    style={{ display: "none" }}
                  />
                  <label
                    htmlFor={`${element.name}-great`}
                    className="emojiLabel emojiGreat"
                  >
                    <span className="emojiImage">
                      {" "}
                      <img
                        style={{ width: "40px", height: "40px" }}
                        alt="average"
                        src={images.Great}
                      />
                    </span>
                    <p className="emojitext">Great</p>
                  </label>
                </div>
              </div>
            </div>
          ))}
          {state.error && (
            <p className="text-danger text-center mb-0">
              Something went wrong, try again !!
            </p>
          )}
          <button
            disabled={feedbackValidation ? true : false}
            className="feedbackSubmit"
            type="submit"
          >
            Submit Feedback
          </button>
        </form>
      </CustomModal>
      <CustomModal show={state.successModal} onHide={handleClose}>
        <div className="text-center">
          <h6 className="mb-3">Feedback submitted successfully.</h6>
          <button className="feedbackSuccess" onClick={handleClose}>
            Ok
          </button>
        </div>
      </CustomModal>
      <CustomModal
        show={!state.is_complete_profile}
        clsClass="btn-hide"
        dialogClassName="complete-profile-modal"
      >
        <img
          src={images.profile}
          className="complete-profile-image"
          alt="profile"
        />
        <div className="modal-heading">Complete Profile</div>
        <div className="profile-modal-data">
          To help us know you better, please complete your profile
        </div>
        <div className="profile-more-info">
          You will receive an SMS containing an one time link to fill out the
          form.
        </div>

        <div className="profile-buttons">
          <button className="ask-ltr-btn" onClick={handleCloseProfileform}>
            Ask Later
          </button>
          <button className="get-sms-btn" onClick={sendSmsToStudent}>
            Get SMS
          </button>
        </div>
      </CustomModal>
      <CustomModal
        show={state.showFeePendingPopup}
        onHide={handleCloseFeePendingModal}
        clsClass="btn-hide"
        dialogClassName="fee-pending-modal"
      >
        <img
          src={images.pendingDue}
          className="fee-pending-image"
          alt="warning"
        />
        <div className="fee-pending-heading">{state.feePendingData?.title}</div>
        <div className="fee-description">
          {state.feePendingData?.description}
        </div>
        <div className="feepending-table">
          <table>
            {state.feePendingData?.dues?.map((elem) => (
              <tr>
                <td className="key">{elem.due_text}</td>
                <td className="value">{elem.due_value}</td>
              </tr>
            ))}
          </table>
        </div>

        <div className="fee-due-buttons">
          <div
            className="fee-pending-cancel-btn"
            onClick={handleCloseFeePendingModal}
          >
            Cancel
          </div>

          <div className="fee-pending-pay-btn">
            <a
              href={state.feePendingData?.payment_link}
              target="_blank"
              rel="noopener noreferrer"
            >
              Pay Now
            </a>
          </div>
        </div>
      </CustomModal>
      {state.isPaid === 0 &&
        state.remainingUserTimeToWatchVideo > 0 &&
        !freeWatchModalDismissedSession && (
        <FreeWatchVideosModal
          show={true}
          onHide={handleCloseFreeWatchVideos}
          handleWatchNow={handleWatchNow}
        />
      )}
      <MultipleLoginDetectModal isMultipleLogin={isMultipleLogin} />
      {state?.comboMessage !== null && (
        <ComboMessage comboMessage={state?.comboMessage} />
      )}
      <div
        style={
          state?.comboMessage == null ? { paddingTop: 60 } : { paddingTop: 0 }
        }
      >
        {state.salesData.length > 0 && (
          <SalesBanner data={state.salesData[0]} />
        )}
      </div>
      <div
        className="userDashboardContentComponent_wrapper"
        style={
          state.salesData.length > 0 ? { paddingTop: 30 } : { paddingTop: 101 }
        }
      >
        <div className="userDashboardContentComponent_inner_wrapper">
          {!isEmpty(state.acpsBannerData) && (
            <AcpsHomePageBanner
              acpsBannerData={state.acpsBannerData}
              setState={setState}
            />
          )}

          <div className="slider_container">
            <div className="container">
              <DashboardSlider />
            </div>
          </div>
          {Array.isArray(state.flashSalesData) &&
            state.flashSalesData.length > 0 && (
              <FlashSale data={state.flashSalesData[0]} />
            )}

          {state.isPaid1 === 0 && state.remainingUserTimeToWatchVideo > 0 && (
            <TenHoursFreeVideosBanner history={history} />
          )}
          <div className="subject_collection_container">
            <SubjectCollectionView history={history} />
          </div>
          <div className="our_course_target">
            <div className="container">
              <div className="btn_wrapper" style={{ width: "270px" }}>
                <a href="#OurCourses" id="explore-courses" style={{ display: "flex" }}>
                  <span className="explore-text">Explore our Courses</span>
                  <span className="icon" style={{ marginTop: "-17px" }}>
                    <img src={images.exploreCourse} alt="img" />
                  </span>
                </a>
              </div>
            </div>
          </div>

          {state?.comboPackagesData?.combo_packages?.length > 0 && (
            <ComboPackages comboPackagesData={state?.comboPackagesData} />
          )}

          {showNewTrailModal &&
            showFreeTrailModalData?.home_benefits?.length > 0 && (
              <FreeBenifits
                freeBenefits={showFreeTrailModalData.home_benefits}
              />
            )}
          <div className="aits_banner_container">
            <div className="container">
              <AitsBanner
                is_Amrit={state.is_Amrit}
                aits_pdf={state.aits_pdf}
                amrit_pdf={state.amrit_pdf}
              />

              {showFreeTrialModal && freeTrialData && (
                <FreeTrialBanner
                  trialDays={freeTrialData.trialDays || 0}
                  popupTitle={freeTrialData.popupTitle}
                  popupDescription={freeTrialData.popupDescription}
                  handleEnrollClick={fetchTrial}
                />
              )}

              {showDiscountBanner && discountData && (
                <DiscountBanner
                  title={discountData.title}
                  description={discountData.description}
                  discountPercent={discountData.discountPercent}
                  couponCode={discountData.couponCode}
                  couponNote={discountData.couponNote}
                  history={history}
                  packageId={discountData.packageId}
                />
              )}
            </div>
          </div>

          {userPreference?.targetDetails[0]?.target_id !== 11 && (
            <div className="slider_container">
              <div className="container">
                <NewOfferingsSlider state={state.newofferings} />
              </div>
            </div>
          )}
          <div className="scheduleClassBx_wrapper">
            <div className="container">
              <ScheduleClass history={history} isPaid={state.isPaid} />
            </div>
          </div>

          {state.testimonialData.length > 0 && (
            <Testimonial data={state.testimonialData} />
          )}
          <div className="our_course_package" id="OurCourses">
            <div className="container">
              <Our_course_package history={history} />
            </div>
          </div>
          <div className="last_paused_video_container">
            <LastPausedVideo history={history} />
          </div>

          {!isEmpty(state.programs) ? (
            <div className="institute_wrapper">
              <div className="container">
                <div className="institute_title">
                  <h4>Offline Programs</h4>
                </div>

                <div className="institute_inner_wrapper">
                  {!isEmpty(state.programs)
                    ? state.programs.map((element) => {
                        return (
                          <div
                            className="institute_box_wrapper"
                            style={{
                              backgroundImage: `url(${images.homepageBanner})`,
                            }}
                          >
                            <div className="institute_box">
                              <h4 className="pgrm_name">{element.name}</h4>
                              <div className="pgrm-description">
                                {element.description}
                              </div>
                              <div className="date_content">
                                <div className="starting_from_text">
                                  Starting From
                                </div>
                                <div className="pgrm_date">{element.date}</div>
                              </div>
                              <div className="price_content">
                                <div className="price_text">Price</div>
                                <div className="pgrm_price">
                                  ₹ {element.price}
                                </div>
                              </div>
                              <div
                                style={{ cursor: "pointer" }}
                                className="know_more_text"
                                onClick={() =>
                                  window.open(element?.url, "_blank")
                                }
                              >
                                Know More
                              </div>
                              <div className="pgrm_terms">
                                {element.image_content}
                              </div>
                            </div>
                          </div>
                        );
                      })
                    : null}
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </div>
      <ToastContainer />
    </Fragment>
  );
};

export default UserDashboardContentComponent;
